
import { DefectModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { defectsStore } from '@/libs/defects/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import DefectDialog from '../components/DefectDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        DefectDialog,
    },
})
export default class Defects extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('defects.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('defects.name'), value: 'name', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: DefectDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return defectsStore.useGetter(CrudGetter.Pending);
    }

    get items(): DefectModel[] {
        return [...defectsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...defectsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        defectsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<DefectModel>(
            [
                { field: 'code', index: 1, order: 'asc' },
                { field: 'name', index: 2, order: 'asc' },
            ],
            this.getFilters()
        );
    }

    open(item: DefectModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
